/**
 * Formats a number with a given format.
 * @param number The number to format (gets rounded to 2 decimal places)
 * @param suffix The suffix to append to the number (e.g. 'mb')
 * @returns The formatted string (e.g. '1.23mb')
 */
function formatNumber(input: number | string, suffix: string = ''): string {
  let number = 0;

  if (typeof input === 'string') {
    number = Number.parseFloat(input);
  } else if (typeof input === 'number') {
    number = input;
  }

  if (number === 0) {
    return `0${suffix}`;
  }
  const value = Math.round(number * 100) / 100;

  // if value is .00, remove it from the string
  const formattedValue = value.toFixed(2).replace(/\.00$/, '');

  if (suffix) {
    return `${formattedValue}${suffix}`;
  }

  return `${formattedValue}`;
}

export default formatNumber;
